<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.61182 12.4118C11.3609 8.66272 17.4392 8.66272 21.1883 12.4118L24 15.2235L26.8118 12.4118C30.5608 8.66272 36.6392 8.66272 40.3882 12.4118C44.1373 16.1608 44.1373 22.2392 40.3882 25.9882L24 42.3764L7.61182 25.9882C3.86279 22.2392 3.86279 16.1608 7.61182 12.4118Z"
    fill="currentColor"
  />
</svg>
